if (!customElements.get('mobile-nav')) {
    class MobileNav extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.initSwiper();
            this.setMobileMenuHeight();
            // this.expandSwiper();
        }

        initSwiper() {
            const swiperContainers = this.querySelectorAll('.mobile-menu-swiper-container');
            this.swipers = [];

            if (swiperContainers.length) {
                swiperContainers.forEach((swiperElementContainer, index) => {
                    const swiperElement = swiperElementContainer.querySelector('.swiper');
                    const scrollbar = swiperElementContainer.querySelector('.swiper-scrollbar');

                    const swiper = new Swiper(swiperElement, {
                        slidesPerView: 2,
                        spaceBetween: 15,
                        observer: true,
                        scrollbar: {
                            el: scrollbar || null,
                        },
                        on: {
                            observerUpdate: function () {
                                const parent = $(swiperElement).parent('.mobile-menu-swiper-container[data-hide=true]');
                                parent.css({
                                    'display': 'none'
                                })
                            },
                        },
                    });
                    this.swipers.push(swiper);

                });
            }
        }

        setMobileMenuHeight() {
            const announcementBar = document.querySelector('.announcement-bar-section');
            if (announcementBar) {
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        console.log(
                            `Element is ${entry.isIntersecting ? 'in' : 'out of'} the viewport.`
                        );
                        if (entry.isIntersecting) {
                            const annoucmentBarHeight = announcementBar.offsetHeight;
                            document.documentElement.style.setProperty('--annoucment-bar-height', annoucmentBarHeight + 'px');
                        } else {
                            document.documentElement.style.setProperty('--annoucment-bar-height', 0 + 'px');
                        }
                    });
                });

                observer.observe(announcementBar);
            } else {
                console.warn('Announcement bar not found!');
            }
        }

        expandSwiper() {
            const expandTitles = this.querySelectorAll('.menu-mobile-child-item-title');
            expandTitles.forEach((title) => {
                title.addEventListener('click', () => {
                    const $swiperContainer = $(title).next('.mobile-menu-swiper-container');

                    if ($swiperContainer.length) {
                        const isExpanded = title.getAttribute('aria-expanded') === 'true';
                        if (isExpanded) {
                            title.setAttribute('aria-expanded', 'false');
                            $swiperContainer.slideUp(300);
                        } else {
                            title.setAttribute('aria-expanded', 'true');
                            $swiperContainer.slideDown(300);
                        }
                    }
                });
            });
        }

    }
    customElements.define('mobile-nav', MobileNav);
}